const DEFAULT_ERROR_MAP = {
  access_denied: "Access denied",
};

export const formatApiErrorMessage = (message, { map = {} } = {}) => {
  if (!message || Array.isArray(message)) {
    return null;
  }

  if (typeof message === "object") {
    return Object.entries(message)
      .map(([key, value]) => `${key}: ${value}`)
      .join(", ");
  }

  const resolved = { ...DEFAULT_ERROR_MAP, ...map }[message];
  return resolved || message;
};

export const throwApiError = (dataOrMessage, options = {}) => {
  const message =
    dataOrMessage &&
    typeof dataOrMessage === "object" &&
    !Array.isArray(dataOrMessage)
      ? dataOrMessage.message
      : dataOrMessage;

  const formatted = formatApiErrorMessage(message, options);
  if (formatted) {
    throw formatted;
  }
};

export const parseApiError = async (response) => {
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  const status = response.status;
  const message =
    (data &&
      typeof data === "object" &&
      !Array.isArray(data) &&
      data.message) ||
    (typeof data === "string" ? data : null);

  const fieldErrors =
    data &&
    typeof data === "object" &&
    !Array.isArray(data) &&
    !data.message &&
    !data.error &&
    !data.statusCode
      ? data
      : null;

  const err = new Error(message || "Request failed");
  err.status = status;
  err.message =
    status === 403
      ? "Access denied"
      : message || err.message || "Request failed";
  err.fieldErrors = fieldErrors;
  err.data = data;
  throw err;
};
